<template>
    <v-container fluid>
        <v-row>
            <v-col>
                <h4 class="text-h4">Completed Purchase Orders</h4>
                <p class="text-subtitle-1">Purchase Orders Completion Report</p>
                <v-divider></v-divider>
            </v-col>
        </v-row>
        <v-row>
            <v-col v-if="hasPermission(permissions.purchase_order.close)">
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2"
                    elevation="2"
                    @click="handleSelectedOrders"
                    >
                    Close Orders
                    </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-text-field
                    label="filter"
                    v-model="filter"
                    prepend-inner-icon="mdi-filter"
                    shaped
                    filled
                    dense
                    single-line
                    hide-details>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters>
            <v-progress-linear indeterminate v-if="loading"/>
            <v-col>
                <v-col>
                    <v-data-table
                        dense
                        v-model="selected"
                        :headers="headers"
                        :items="filterdList"
                        :show-select="hasPermission(permissions.purchase_order.close)"
                        item-key="purchase_order_id"
                    >
                        <template  v-slot:item.purchase_order_code="{ item }">
                            <router-link :to="{ name: 'PurchaseOrderDisplay', params: { id: item.purchase_order_id }}">{{item.purchase_order_code}}</router-link>
                        </template>
                    </v-data-table>
                </v-col>
            </v-col>
        </v-row>
        <PAlert v-model="alert.value" v-bind="alert"/>
    </v-container>
</template>

<script>
import { mapGetters } from 'vuex';
import { formatNumber } from 'accounting';
import permissions from './../../data/permissions';
import PAlert from './../../components/common/PAlert.vue';
import OrderAPI from './../../services/purchase/order'
import { getOrdersCompletion } from '../../services/purchase/reports'

export default {
    name: "PurchaseOrderCompletion",
    components: {
        PAlert
    },
    data() {
        return {
            selected: [],
            showSelect: false,
            headers: [
                { text: "Purchase Order", value: "purchase_order_code" },
                { text: "Supplier", value: "supplier_name" },
                { text: "Date", value: "purchase_order_date" }
            ],
            loading: false,
            list:[],
            filter: "",
            permissions: permissions,
            alert: {
                value: false,
                title: "Alert",
                content: "Are you sure?",
                callback: null
            },
        }
    },
    computed: {
        ...mapGetters({
            hasPermission: "authentication/hasPermission"
        }),
        filterdList() {
            return this.list.filter( each => {
                return each.purchase_order_code.toLowerCase().indexOf(this.filter) > -1 ||
                       each.supplier_name.toLowerCase().indexOf(this.filter) > -1
            });
        },
    },
    methods: {
        formatNumber,
        async getCompletedOrders() {
            try {
                this.loading = true;
                let res = await getOrdersCompletion();
                this.list = res.data;
            }finally {
                this.loading = false;
            }
        },
        handleSelectedOrders() {
            this.alert = {...this.alert, content: "Are you sure you want to CLOSE selected orders?", value: true, callback: this.closeOrders }
        },
        async closeOrders() {
            this.loading = true;
            let data = this.selected.map(each => ({ purchase_order_id: each.purchase_order_id }));
            await OrderAPI.closeBulk({...data});
            await this.getCompletedOrders();
            this.loading = false;
        }
    },
    created() {
        this.getCompletedOrders();
    }
}
</script>

<style>

</style>